import { render, staticRenderFns } from "./SearchResultEventItem.vue?vue&type=template&id=647c5a91&scoped=true&"
import script from "./SearchResultEventItem.vue?vue&type=script&lang=js&"
export * from "./SearchResultEventItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultEventItem.vue?vue&type=style&index=0&id=647c5a91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c5a91",
  null
  
)

export default component.exports